import classnames from 'classnames';

import styles from './counter.module.css';

interface CounterProps {
  value: number | undefined;
  className?: string;
}

const Counter: React.FC<CounterProps> = ({ value, className }) => {
  return <span className={classnames(styles.counter, className)}>{value}</span>;
};

export default Counter;
